import React from 'react'
import withView from '../../../../cmn/docAutomation/withView';
import FormDialog from '../../../../../library/form/components/FormDialog';
import FormTitle from '../../../../../library/form/components/FormTitle'
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormInput from '../../../../../library/form/components/FormInput';
import FormSH from '../../../../../library/form/components/FormSH';
import FormRichText from '../../../../../library/form/components/FormRichText';
import FormROValue1 from '../../../../../library/form/components/FormROValue1';

const ProdDeductionTaskSH = (props)=>{
    const { formObject, viewData, dynamicViewData, ...restProps } = props;

    return(
        <FormDialog dynamicViewData={dynamicViewData} onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" }, actionParam:{showModeID:"sh", actionType: "saveDeductionSlip" } }}
            formStyle={{ width: '500px' }}
            contentStyle={{ height: '250px',overflowY: "scroll" }}
            formTitle={<FormTitle formObject={formObject} value='Deduction Slip' />}
            formObject={formObject} >
        <div>
            <ul>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskId" }} value="ID" />
                        </span>
                        <FormROValue1 className="uiVal" formObject={formObject} rowKey="" action={{ paramName: "taskId" }} />
                    </li>
                    <li className="uiSpacer10">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskDate" }} value="Date" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className=""
                            action={{ InputType: "dp", paramName: "taskDate" }} />
                    </li>
                    <li className="uiSpacer10">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type1" }} value="Deduction Type" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="acCompanyTxt" className="uiInput"
                            action={{ InputType: "ac", paramName: "type1", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />

                        <FormSH formObject={formObject} rowKey="" 
                            action={{ actionId: "new", paramName: "type1",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        >
                        </FormSH>
                    </li>
                    <li className="uiSpacer10">
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type2" }} value="Reason" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" id="acCompanyTxt" className="uiInput"
                            action={{ InputType: "ac", paramName: "type2", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />

                        <FormSH formObject={formObject} rowKey="" 
                            action={{ actionId: "new", paramName: "type2",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        >
                        </FormSH>
                    </li>

                </ul>
                <div className="uiSpacer10">
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskDesc" }} value="Remarks" />
                    </span>
                    <FormRichText formObject={formObject} rowKey="" rows="4" cols="40" className=""
                        action={{ paramName: "taskDesc" }}
                    />
                </div>

        </div>

        </FormDialog>
    )
}

export default withView(ProdDeductionTaskSH, "prodDeduction", "")
